(function () {
  if (window.__scCollectionAnalyticsLoaded) return;
  window.__scCollectionAnalyticsLoaded = true;

  const viewedSections = new Set();

  function publish(eventName, data) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish(eventName, data);
    }
  }

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function observeSection(element) {
    if (!element || element.dataset.scAnalyticsObserved === 'true') return;

    element.dataset.scAnalyticsObserved = 'true';
    sectionObserver.observe(element);
  }

  const sectionObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        const element = entry.target;
        const collectionHandle = element.dataset.scCollection || '';
        const sectionId = element.dataset.scSectionView || '';

        if (!collectionHandle || !sectionId) return;

        const key =
          window.location.pathname +
          '|' +
          collectionHandle +
          '|' +
          sectionId;

        if (viewedSections.has(key)) {
          sectionObserver.unobserve(element);
          return;
        }

        viewedSections.add(key);

        publish('saloncapes:collection_section_view', {
          collection_handle: collectionHandle,
          section_id: sectionId,
          source_url: window.location.href
        });

        sectionObserver.unobserve(element);
      });
    },
    {
      threshold: 0.25
    }
  );

  function scanSections(root) {
    const scope = root || document;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches('[data-sc-section-view][data-sc-collection]')
    ) {
      observeSection(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('[data-sc-section-view][data-sc-collection]')
        .forEach(observeSection);
    }
  }

    document.addEventListener('click', function (event) {
    const link = event.target.closest(
      '[data-sc-track="collection_content_click"]'
    );

    if (!link) return;

    publish('saloncapes:collection_content_click', {
      collection_handle: link.dataset.scCollection || '',
      section_id: link.dataset.scSection || '',
      destination_type: link.dataset.scDestinationType || '',
      link_id: link.dataset.scLinkId || '',
      link_text: normalizeText(link.textContent),
      destination_url: link.href || '',
      source_url: window.location.href
    });
  }, true);

  scanSections(document);

  const mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          scanSections(node);
        }
      });
    });
  });

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();